import React from "react";
// import JSONPretty from "react-json-pretty";
import { connect } from "react-redux";
import { Input } from "@revvsales/components";
import { RevvForm, ErrorMessages } from "../../../../commonComponents";

import {
  CustomFieldInitialValuesMap,
  CustomFieldComponentRules,
  CustomFieldComponentMessages,
} from "./CustomFieldRulesMap";

// Actions Imports
import { DocumentTemplateActions } from "../../../../actions";

const {
  toggleDynamicFieldView,
  setMetaFieldValues,
  setFlagForDefault,
  metaValidStatus,
} = DocumentTemplateActions;

class SingleLineTextField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDefaultValue: this._getShowDefaultValue(props),
      singleLineTextFieldValues: this._getDataForPrepopulate(props),
    };
  }

  _getShowDefaultValue = propsData => {
    let returnData = false;
    if (propsData.meta && propsData.meta.default) {
      returnData = true;
    }
    return returnData;
  };

  _getDataForPrepopulate = propsData => {
    let returnData = JSON.parse(
      JSON.stringify(CustomFieldInitialValuesMap.SINGLE_LINE_TEXT),
    );
    if (propsData.meta && propsData.meta.default) {
      returnData = propsData.meta;
    }
    return returnData;
  };

  _toggleDefaultValue = () => {
    const { showDefaultValue } = this.state;
    this.setState({ showDefaultValue: !showDefaultValue });
    this.props.setFlagForDefault(!showDefaultValue);
  };

  render() {
    const { showDefaultValue, singleLineTextFieldValues } = this.state;
    console.debug("Common field values");
    console.debug(singleLineTextFieldValues);
    return (
      <React.Fragment>
        <Input
          id="checkbox"
          type="checkbox"
          data-test="SingleLineTextField-checkbox"
          checked={showDefaultValue}
          onChange={() => this._toggleDefaultValue()}
          className="dynamicfieldcustom-footer-input errorborder"
        />
        <span className="dynamicfieldcustom-footer-checkboxinput">
          This has a default value
        </span>
        {showDefaultValue && (
          <RevvForm
            initialFormValue={singleLineTextFieldValues}
            customFieldName="SINGLE_LINE_TEXT"
            customFieldComponentRules={CustomFieldComponentRules}
            customFieldComponentMessages={CustomFieldComponentMessages}
            render={formProps => {
              const {
                handleChange,
                handleBlur,
                messages,
                touched,
                errors,
                values,
                isValid,
              } = formProps;
              const allInAll = {
                isValid,
                messages,
                touched,
                errors,
                values,
              };
              console.debug("allInAll", allInAll);
              if (isValid) {
                this.props.metaValidStatus(true);
                this.props.setMetaFieldValues(values);
              } else {
                this.props.metaValidStatus(false);
                this.props.setMetaFieldValues({});
              }
              return (
                <React.Fragment>
                  <div className="dynamicfieldcustom-revvform">
                    <span className="revvform-label">
                      Default value
                      <span className="requiredwitherr-input"> *</span>
                    </span>
                    <Input
                      autoFocus
                      id="default"
                      name="default"
                      data-test="SingleLineTextField-default"
                      type="text"
                      value={values && values.default}
                      placeholder="Enter field default value"
                      className="dynamicfieldcustom-footer-input errorborder"
                      onChange={value => handleChange(value)}
                      onBlur={value => handleBlur(value)}
                      required
                    />
                    {allInAll.messages.default && (
                      <ErrorMessages
                        messages={allInAll.messages.default.required}
                      />
                    )}
                  </div>
                </React.Fragment>
              );
            }}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    meta,
  } = state.TemplateStore.dynamicFields.selectedDynamicFieldForUpdate;
  return {
    meta,
  };
};

const mapDispatchToProps = {
  toggleDynamicFieldView,
  setFlagForDefault,
  metaValidStatus,
  setMetaFieldValues,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SingleLineTextField);



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/DynamicFieldComponents/SingleLineTextField.js